import axios, { AxiosResponse, CreateAxiosDefaults } from "axios";
import type { SernumsResponse } from "./sernums.interface";

interface RfidResponse {
  Token: string;
  message: string;
}

const bridgeAuthHeader = (): string => {
  return `Bearer ${localStorage.getItem("authToken") ?? "my_secure_token_123"}`;
};

const options: CreateAxiosDefaults = {
  baseURL: process.env.REACT_APP_JUMPER_API_BASE_URL ?? "https://jumper.scodix.org",
  headers: {
    Authorization: bridgeAuthHeader(),
    "Content-Type": "application/json"
  }
};



const axiosClassic = axios.create(options);

axiosClassic.interceptors.request.use((config) => {
  if (config.headers) {
    config.headers.Authorization = bridgeAuthHeader();
  }
  return config;
});

export const sernumsService = {
  getSernums: async (param: string): Promise<AxiosResponse<SernumsResponse, any>> => {
    return await axiosClassic.get("/get-erp-v2", {
      params: {
        sernum: param
      }
    });
  },

  sendPassword: async (password: string): Promise<AxiosResponse<any, any>> => {
    return await axiosClassic.get("/validate_password", {
      params: {
        password
      }
    });
  },

  generatePassword: async (someJson: string): Promise<AxiosResponse<{ encrypt: string }, any>> => {
    
    // const unstringify = JSON.parse(someJson);

    const payload = {
        passcode: someJson
    };
    console.log("Payload to be sent:", JSON.stringify(payload, null, 2)); 
    return await axiosClassic.post("/genpass-v2", payload);
  },

  // /bi/new_machine returns:
  // {
  //   "message": "Machine, Dashboard, and CurrentPrint created successfully",
  //   "machine_id": <id>
  // }
  newMachine: async (someJson: string): Promise<AxiosResponse<{ message: string; machine_id: number }, any>> => {
    
    // const unstringify = JSON.parse(someJson);
    console.log("Payload to be sent:", JSON.stringify(someJson, null, 2)); 
    return await axiosClassic.post("/bi/new_machine", someJson);
  },

  generateRfidPassword: async (someJson: string): Promise<AxiosResponse<RfidResponse>> => {
    console.log("Payload to be sent:", JSON.stringify(someJson, null, 2));
    return await axiosClassic.post("/rfid_password", someJson);
  }


};
